import {
  captureCandidateContext,
  getCandidateSession,
} from 'candidate-app/candidateCapability';
import type { InterviewSessionBootstrap } from 'api/generated/types';
import { CallType } from 'api/generated/types/callType';
import { isRecord } from 'utils/typeGuards';

export interface ExternalSchedulingBootstrap extends InterviewSessionBootstrap {
  external_agent?: boolean;
  call_type?: CallType | null;
  sms_verification_required?: boolean;
}
/** The baseline session parser validates shared fields; this boundary validates its extension. */
function isExternalSchedulingBootstrap(
  value: unknown
): value is ExternalSchedulingBootstrap {
  return (
    isRecord(value) &&
    value.external_agent === true &&
    (value.call_type == null ||
      value.call_type === CallType.PHONE ||
      value.call_type === CallType.WEB) &&
    (value.sms_verification_required === undefined ||
      typeof value.sms_verification_required === 'boolean')
  );
}
export function externalSchedulingSession() {
  const session = getCandidateSession(captureCandidateContext());
  if (!session) return null;
  const bootstrap = session.bootstrap;
  return isExternalSchedulingBootstrap(bootstrap)
    ? { ...session, bootstrap }
    : null;
}
